export const getBoardIdFromUrl = (url: string): null | string => {
  if (!url) return null;
  const pattern =
    /^(?:https:\/\/)?(?:www\.)?(?:[a-zA-Z0-9-]+\.)?miro\.com\/(app)\/(board)\/([0-9a-zA-Z_\-=]{12})(?:\/?([^?]+)?(.*))?$/;
  const matched = url.match(pattern);
  if (!matched) return null;
  return matched[3] || null;
};
